import React, { LegacyRef, forwardRef } from 'react';

import './styles.scss';

import { FlexContainerProps } from 'types/flexContainerProps';

const FlexContainer = forwardRef((props: FlexContainerProps, ref: LegacyRef<HTMLDivElement>): React.JSX.Element => {
  const style = `${props.display} ${props.justify} ${props.align}${props.position ? ` ${props.position}` : ''}${props.wrap ? ' --wrap' : ''}${props.extraClasses ? ` ${props.extraClasses}` : ''}`;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      id={props.id}
      ref={ref}
      className={style}
      data-testid={props.testid}
      onClick={
        props.onClick
          ? () => {
            if (props.onClick) {
              props.onClick();
            }
          }
          : undefined
      }
    >
      {props.children}
    </div>
  );
});

export default FlexContainer;
